import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { ClipboardScoreLink } from "./ClipboardScoreLink";

interface EducateNewWorkerDescriptionProps {
  shiftLeadTimeInHours: number;
  cancellationPoints: number;
  currentClipboardScore: number;
  restrictionInDays: number;
}

export function EducateNewWorkerDescription(props: EducateNewWorkerDescriptionProps) {
  const { shiftLeadTimeInHours, cancellationPoints, currentClipboardScore, restrictionInDays } =
    props;

  const cancellationNoticeText = shiftLeadTimeInHours > 24 ? "within 24 hours" : "now";
  return (
    <Stack paddingLeft={8} paddingRight={8} alignItems="center">
      <Stack spacing={5} paddingLeft={8} paddingRight={8}>
        <Text variant="body2" sx={{ textAlign: "center" }}>
          <Text
            inline
            bold
            variant="body2"
            color={(theme) => theme.palette.shift?.bookingRequest.text}
            style={{ fontWeight: "bold" }}
          >
            All cancellations
          </Text>{" "}
          result in lost points, but the earlier you cancel, the less points you&apos;ll lose.
        </Text>
        <Text variant="body2" sx={{ textAlign: "center" }}>
          Cancelling {cancellationNoticeText} will cost you at least {cancellationPoints} points,
          dropping your score to <strong>{cancellationPoints + currentClipboardScore}</strong>. Once
          you reach <strong>0 points or you No Show</strong>, your account will be{" "}
          <Text
            inline
            bold
            variant="body2"
            color={(theme) => theme.palette.shift?.bookingRequest.text}
            style={{ fontWeight: "bold" }}
          >
            restricted for {restrictionInDays} days
          </Text>
          .
        </Text>
      </Stack>
      <ClipboardScoreLink />
    </Stack>
  );
}
